export const tableModal = (buttonToggle, closeToggle) => {
    const openButtons = document.querySelectorAll(buttonToggle);
    const closeButtons = document.querySelectorAll(closeToggle);

    function hideBodyOverflow() {
        document.body.classList.add('hide-overflow');
    }

    function clearBodyOverflow() {
        document.body.classList.remove('hide-overflow');
    }

    function openModal() {
        const modal = this.closest('.js-table-wrapper').nextElementSibling;
        modal.classList.add('is-visible');
        hideBodyOverflow();
    }

    function closeModal() {
        const modal = this.closest('.js-table-modal');
        modal.classList.remove('is-visible');
        clearBodyOverflow();
    }

    openButtons.forEach((button) => {
        button.addEventListener('click', openModal);
    });

    closeButtons.forEach((button) => {
        button.addEventListener('click', closeModal);
    });
};
